import { createContext } from 'react';

const AuthenticationContext = createContext({
  user: undefined,
  getMe: () => {}
});

export { AuthenticationContext };
